import { DomHelper } from '@bryntum/schedulerpro';
import { Skeleton } from 'antd';
import React, { useCallback, useRef } from 'react';
// eslint-disable-next-line import/no-internal-modules
import { renderToStaticMarkup } from 'react-dom/server';
import styled from 'styled-components';
import { PageLoading } from 'components/atoms/loading';
import { SchedulerReference } from '../types';

const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;
const Column = styled.div<{ width: number }>`
  width: ${({ width }) => `${width}px`};
  border-right: 1px solid var(--border-color);
  ${ItemWrapper} {
    padding: var(--spacing-03) var(--spacing-05) var(--spacing-06);
    border-bottom: 1px solid var(--border-color);
    &:last-child {
      border: none;
    }
  }
`;
const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  border-bottom: 1px solid var(--border-color);
  margin-left: var(--spacing-03);
`;

const Mask = (): JSX.Element => {
  return (
    <>
      <PageLoading css />
      <Wrapper>
        <Column width={360}>
          {[...Array(12)].map(() => (
            <ItemWrapper>
              <Skeleton.Avatar active /> <Skeleton active paragraph={false} />
            </ItemWrapper>
          ))}
        </Column>
        <Column width={360} />
        <Column width={360} />
        <Column width={360} />
        <Column width={360} />
      </Wrapper>
    </>
  );
};

interface Props {
  schedulerRef: SchedulerReference;
}
interface Result {
  showMask: () => void;
  hideMask: () => void;
}
export const useMaskRenderer = ({ schedulerRef }: Props): Result => {
  const maskRef = useRef<ReturnType<typeof DomHelper.createElement>>();

  const showMask = useCallback(() => {
    if (maskRef.current != null) {
      return;
    }
    const maskDiv = DomHelper.createElement({
      tag: 'div',
      className: 'custom-mask',
      children: [
        {
          html: renderToStaticMarkup(Mask()),
        },
      ],
    });

    if (schedulerRef.current?.instance.element) {
      DomHelper.append(schedulerRef.current?.instance.element, maskDiv);
    }
    maskRef.current = maskDiv;
  }, [schedulerRef]);
  const hideMask = useCallback(() => {
    if (schedulerRef.current != null) {
      DomHelper.removeEachSelector(
        schedulerRef.current.instance.element,
        '.custom-mask',
      );
    }
    maskRef.current = undefined;
  }, [schedulerRef]);

  return {
    showMask,
    hideMask,
  };
};
